import { render, staticRenderFns } from "./HotNews.vue?vue&type=template&id=4f5bc348&scoped=true&"
import script from "./HotNews.vue?vue&type=script&lang=js&"
export * from "./HotNews.vue?vue&type=script&lang=js&"
import style0 from "./HotNews.vue?vue&type=style&index=0&id=4f5bc348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5bc348",
  null
  
)

export default component.exports